import moment from 'moment-timezone'

export interface Timezone {
  value: string
  label: string
  offset: string
  translationKey: string
}

export const TIMEZONES: Timezone[] = [
  { value: '+00:00', label: 'Europe/London', offset: '+00:00', translationKey: 'event_ssids.timezones_full.europe_london' },
  { value: '+01:00', label: 'Europe/Paris', offset: '+01:00', translationKey: 'event_ssids.timezones_full.europe_paris' },
  { value: '+02:00', label: 'Europe/Athens', offset: '+02:00', translationKey: 'event_ssids.timezones_full.europe_athens' },
  { value: '+03:00', label: 'Europe/Moscow', offset: '+03:00', translationKey: 'event_ssids.timezones_full.europe_moscow' },
  { value: '+04:00', label: 'Asia/Dubai', offset: '+04:00', translationKey: 'event_ssids.timezones_full.asia_dubai' },
  { value: '+05:00', label: 'Asia/Karachi', offset: '+05:00', translationKey: 'event_ssids.timezones_full.asia_karachi' },
  { value: '+06:00', label: 'Asia/Dhaka', offset: '+06:00', translationKey: 'event_ssids.timezones_full.asia_dhaka' },
  { value: '+07:00', label: 'Asia/Bangkok', offset: '+07:00', translationKey: 'event_ssids.timezones_full.asia_bangkok' },
  { value: '+08:00', label: 'Asia/Shanghai', offset: '+08:00', translationKey: 'event_ssids.timezones_full.asia_shanghai' },
  { value: '+09:00', label: 'Asia/Tokyo', offset: '+09:00', translationKey: 'event_ssids.timezones_full.asia_tokyo' },
  { value: '+10:00', label: 'Australia/Sydney', offset: '+10:00', translationKey: 'event_ssids.timezones_full.australia_sydney' },
  { value: '+11:00', label: 'Pacific/Noumea', offset: '+11:00', translationKey: 'event_ssids.timezones_full.pacific_noumea' },
  { value: '+12:00', label: 'Pacific/Auckland', offset: '+12:00', translationKey: 'event_ssids.timezones_full.pacific_auckland' },
  { value: '-01:00', label: 'Atlantic/Azores', offset: '-01:00', translationKey: 'event_ssids.timezones_full.atlantic_azores' },
  { value: '-02:00', label: 'Atlantic/South_Georgia', offset: '-02:00', translationKey: 'event_ssids.timezones_full.atlantic_south_georgia' },
  { value: '-03:00', label: 'America/Argentina/Buenos_Aires', offset: '-03:00', translationKey: 'event_ssids.timezones_full.america_buenos_aires' },
  { value: '-04:00', label: 'America/Caracas', offset: '-04:00', translationKey: 'event_ssids.timezones_full.america_caracas' },
  { value: '-05:00', label: 'America/New_York', offset: '-05:00', translationKey: 'event_ssids.timezones_full.america_new_york' },
  { value: '-06:00', label: 'America/Chicago', offset: '-06:00', translationKey: 'event_ssids.timezones_full.america_chicago' },
  { value: '-07:00', label: 'America/Denver', offset: '-07:00', translationKey: 'event_ssids.timezones_full.america_denver' },
  { value: '-08:00', label: 'America/Los_Angeles', offset: '-08:00', translationKey: 'event_ssids.timezones_full.america_los_angeles' },
  { value: '-09:00', label: 'America/Anchorage', offset: '-09:00', translationKey: 'event_ssids.timezones_full.america_anchorage' },
  { value: '-10:00', label: 'Pacific/Honolulu', offset: '-10:00', translationKey: 'event_ssids.timezones_full.pacific_honolulu' },
  { value: '-11:00', label: 'Pacific/Midway', offset: '-11:00', translationKey: 'event_ssids.timezones_full.pacific_midway' }
]

export const getTimezoneByValue = (value: string): Timezone | undefined => {
  return TIMEZONES.find(tz => tz.value === value)
}

export const getDefaultTimezone = (): Timezone => {
  return TIMEZONES.find(tz => tz.offset === '+01:00') || TIMEZONES[1]
}

export const getTimezoneOffset = (
  timezone: Timezone,
  date?: Date | string | null,
  time = '00:00'
): string => {
  const datePart = moment(date || undefined).format('YYYY-MM-DD')
  return moment.tz(`${datePart} ${time}`, timezone.label).format('Z')
}

export const getTimezoneByOffset = (
  offset: string,
  date?: Date | string | null,
  time?: string
): Timezone | undefined => {
  return TIMEZONES.find(tz => getTimezoneOffset(tz, date, time) === offset)
}

export const formatTimezoneDisplay = (
  timezone: Timezone,
  t: (key: string) => string,
  date?: Date | string | null,
  time?: string
): string => {
  const location = t(timezone.translationKey)
  const resolvedOffset = date ? getTimezoneOffset(timezone, date, time) : timezone.offset
  const offset = resolvedOffset.replace(/^([+-])0?(\d+):00$/, '$1$2')
  return `UTC ${offset}, ${location}`
}